<template>
  <a :href="href" class="ni-more-link">
    <span>{{ t('newIndex.common.viewMore') }}</span>
    <span class="ni-more-link__icon" aria-hidden="true">
      <svg class="ni-more-link__icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
        <path d="m9 6 6 6-6 6" />
      </svg>
    </span>
  </a>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  href: {
    type: String,
    default: '#',
  },
});

const { t } = useI18n();
</script>
